export default "__VITE_ASSET__DPdZtTTR__"